// @flow

// import {createSelector} from "reselect"
import {parse, isAfter} from "date-fns"
import {t} from "i18next"
import {filterableBabyStates} from "../types"
import type {
  Baby as BabyT,
  SearchItemBaby,
  // BabiesSortBy,
  BabiesState,
  BabiesSortByOrder,
  // BabiesFilters,
  // BabyMadam,
  Action,
} from "../types"

const initialState: BabiesState = {
  madams: [],
  entities: [],
  filters: {},
  query: "",
  sortBy: {
    property: "pickupDate",
    order: "asc",
  },
  listType: "upcoming",
  page: 1,
  totalPages: 1,
}

const babies = (
  state: BabiesState = initialState,
  action: Action
): BabiesState => {
  switch (action.type) {
    case "SET_BABIES":
      return {
        ...state,
        entities: action.babies,
      }
    case "SET_BABIES_PAGE":
      return {
        ...state,
        page: action.page,
      }
    case "SET_BABIES_TOTAL_PAGES":
      return {
        ...state,
        totalPages: action.totalPages,
      }
    case "SET_BABIES_MADAMS":
      return {
        ...state,
        madams: action.madams,
      }
    case "SET_BABY_STATE":
      const {id: babyId, state: babyState} = action
      const entities = [...state.entities]
      return {
        ...state,
        entities: entities.map((b: BabyT): BabyT => {
          if (b.id == babyId) {
            return {...b, state: babyState}
          }
          return b
        }),
      }
    case "SET_BABIES_BABY":
      const {baby} = action
      return {
        ...state,
        entities: [...state.entities].map((b: BabyT) => {
          if (b.id == baby.id) {
            return baby
          }
          return b
        }),
      }
    case "TOGGLE_BABIES_SORT_BY":
      const currentSortByOrder = state.sortBy.order
      const next = toggleSortByOrder(currentSortByOrder)
      return {
        ...state,
        sortBy: {property: action.sortByProp, order: next},
      }
    case "SET_BABIES_FILTER":
      let filterValue
      if (action.filter == "state") {
        const virtualFilterValue = action.value
        filterValue = filterableBabyStates[virtualFilterValue]
        if (filterValue == undefined) {
          // remove filter from state filters but keep the other filters
          const newFilters = {...state.filters}
          delete newFilters.state
          return {...state, filters: newFilters}
        }
      } else {
        filterValue = parseInt(action.value)
      }
      return {
        ...state,
        filters: {...state.filters, [action.filter]: filterValue},
      }
    case "SET_BABIES_QUERY":
      return {...state, query: action.query}
    case "SET_BABIES_LIST_TYPE":
      return {...state, listType: action.listType}
    case "RESET_BABIES_FILTERS":
      return {...initialState}
    default:
      return state
  }
}
// helpers

export const getBabyPartnerNamesConcat = (
  baby: SearchItemBaby | BabyT
): string => baby.family.users.map((u) => u.firstname).join(" & ")

export const getBabySexesConcat = (baby: SearchItemBaby | BabyT): string => {
  let sexes = [t(`babyCard.babyName.sex.${baby.sex || "u"}`)]
  if (baby.sex_2 && baby.sex_2 != "") {
    sexes = [...sexes, t(`babyCard.babyName.sex.${baby.sex_2}`)]
  }
  if (baby.sex_3 && baby.sex_3 != "") {
    sexes = [...sexes, t(`babyCard.babyName.sex.${baby.sex_3}`)]
  }
  return "(" + sexes.join(", ") + ")"
}

export const getUpcomingBabies = (
  babies: $ReadOnlyArray<BabyT>
): $ReadOnlyArray<BabyT> =>
  babies.filter(
    (b) => b.birthDate == null || isAfter(parse(b.birthDate), new Date())
  )

// const babiesSelector = (state) => state.babies.entities
// const filtersSelector = (state) => state.babies.filters
// const sortBySelector = (state) => state.babies.sortBy

// export const getMadamsForBabies = createSelector(
//   babiesSelector,
//   (babies: $ReadOnlyArray<BabyT>): $ReadOnlyArray<BabyMadam> =>
//     sortByF(
//       uniqBy(babies, (b) => b.madam.id).map((b) => b.madam),
//       (m) => m.name
//     )
// )

// export const getFilteredAndSortedBabies = createSelector(
//   babiesSelector,
//   filtersSelector,
//   sortBySelector,
//   (
//     babies: $ReadOnlyArray<BabyT>,
//     filters: BabiesFilters,
//     sortBy: BabiesSortBy
//   ) => {
//     let processed = babies
//     if (Object.keys(filters).length > 0) {
//       processed = [...babies].filter((b) => babyPassesFilter(b, filters))
//     }
//     processed = sortByF(processed, (baby) => {
//       switch (sortBy.property) {
//         case "name":
//           if (sortBy.order != "default") {
//             return baby.family.users[0].firstname
//           }
//           break
//
//         case "state":
//           if (sortBy.order != "default") {
//             return baby.state
//           }
//           break
//
//         case "pickupDate":
//           if (sortBy.order != "default") {
//             return baby.pickupDate
//           }
//           break
//       }
//     })
//     if (sortBy.order == "desc") {
//       processed = processed.reverse()
//     }
//     return processed
//   }
// )

// export const getFilteredAndSortedBabies = (
//   babies: $ReadOnlyArray<BabyT>,
//   filters: BabiesFilters,
//   sortBy: BabiesSortBy
// ): $ReadOnlyArray<BabyT> => {
//   let processed = babies
//   if (Object.keys(filters).length > 0) {
//     processed = [...babies].filter(b => babyPassesFilter(b, filters))
//   }
//   processed = sortByF(processed, baby => {
//     switch (sortBy.property) {
//       case 'name':
//         if (sortBy.order != 'default') {
//           return baby.family.users[0].firstname
//         }
//         break
//
//       case 'state':
//         if (sortBy.order != 'default') {
//           return baby.state
//         }
//         break
//
//       case 'pickupDate':
//         if (sortBy.order != 'default') {
//           return baby.pickupDate
//         }
//         break
//     }
//   })
//   if (sortBy.order == 'desc') {
//     processed = processed.reverse()
//   }
//   return processed
// }

// const babyPassesFilter = (baby: BabyT, filters: BabiesFilters) => {
//   let passes = true
//   map(filters, (filterValue, filterName) => {
//     if (!filterValue) return true
//     switch (filterName) {
//       case "state":
//         if (filterValue instanceof Array && !filterValue.includes(baby.state)) {
//           passes = false
//         }
//         break
//       case "madamId":
//         if (!(filterValue instanceof Array) && filterValue == 0) {
//           passes = true // reset action
//         }
//         if (baby.madam.id !== filterValue) {
//           passes = false
//         }
//         break
//     }
//   })
//   return passes
// }

// export const getBaby = (
//   babies: $ReadOnlyArray<BabyT>,
//   babyListId: number
// ): ?BabyT => {
//   return find(babies, (b) => b.babyListId == babyListId)
// }

export const toggleSortByOrder = (
  val: BabiesSortByOrder
): BabiesSortByOrder => {
  switch (val) {
    case "asc":
      return "desc"
    default:
      return "asc"
  }
}

export default babies
